import theme from 'shell/themes';
import COUNTRIES from 'utils/constants/countries';
import INSTITUTIONS from 'utils/constants/institutions';
import INSTITUTIONS_CA from 'utils/constants/institutions_ca';
import MAJORS from 'utils/constants/majors';
import TIMEZONES from 'utils/constants/timezones';

export { COUNTRIES, INSTITUTIONS, INSTITUTIONS_CA, MAJORS, TIMEZONES };

export const SEMESTER_OPTIONS = Object.freeze([
    { key: '2023-spring/winter', value: '2023 Spring/Winter' },
    { key: '2023-summer', value: '2023 Summer' },
    { key: '2023-fall', value: '2023 Fall' },
    { key: '2024-spring/winter', value: '2024 Spring/Winter' },
    { key: '2024-summer', value: '2024 Summer' },
    { key: '2024-fall', value: '2024 Fall' },
    { key: '2025-spring/winter', value: '2025 Spring/Winter' },
    { key: '2025-SUMMER', value: '2025 Summer' },
]);

export const AVATAR_COLOR_OPTIONS = Object.freeze([
    {
        bgColor: theme.palette.ensightful.error[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.error[600],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.error[100],
        textColor: theme.palette.ensightful.error[900],
    },

    {
        bgColor: theme.palette.ensightful.success[700],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.success[400],
        textColor: theme.palette.ensightful.success[900],
    },
    {
        bgColor: theme.palette.ensightful.success[100],
        textColor: theme.palette.ensightful.success[900],
    },

    {
        bgColor: theme.palette.ensightful.warning[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.warning[500],
        textColor: theme.palette.ensightful.neutral[900],
    },
    {
        bgColor: theme.palette.ensightful.warning[100],
        textColor: theme.palette.ensightful.warning[900],
    },

    {
        bgColor: theme.palette.ensightful.secondary[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.secondary[400],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.secondary[100],
        textColor: theme.palette.ensightful.secondary[900],
    },

    {
        bgColor: theme.palette.ensightful.primary[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.primary[500],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.primary[100],
        textColor: theme.palette.ensightful.primary[900],
    },

    {
        bgColor: theme.palette.ensightful.neutral[800],
        textColor: theme.palette.ensightful.shades[0],
    },
    {
        bgColor: theme.palette.ensightful.neutral[500],
        textColor: theme.palette.ensightful.neutral[900],
    },
    {
        bgColor: theme.palette.ensightful.neutral[200],
        textColor: theme.palette.ensightful.neutral[900],
    },
]);

export const PRONOUNS_OPTIONS = Object.freeze([
    { key: 'hehim', value: 'He/Him' },
    { key: 'sheher', value: 'She/Her' },
    { key: 'theythem', value: 'They/Them' },
    { key: 'zezir', value: 'Ze/Zir' },
    { key: 'other', value: 'Other' },
    { key: 'undisclosed', value: 'Prefer not to say' },
]);

export const EN_PROFICIENCY_OPTIONS = Object.freeze([
    { key: 'native', value: 'Native Speaker' },
    { key: 'advanced', value: 'Advanced' },
    { key: 'upperintermediate', value: 'Upper-intermediate' },
    { key: 'intermediate', value: 'Intermediate' },
    { key: 'lowerintermediate', value: 'Lower-intermediate' },
    { key: 'beginner', value: 'Beginner' },
]);

export const AI_FEEDBACK_LIMIT = 3;

export const ROLES = Object.freeze({
    STUDENT: 'student',
    INSTRUCTOR: 'instructor',
});

export const SUBMISSION_TYPES = Object.freeze({
    ASSIGNMENT: 'assignment',
});

export const DRAFT_TYPES = Object.freeze({
    DRAFT: 'draft',
    FINAL_DRAFT: 'final_draft',
});

export const ASSIGNMENT_SUBMISSION_TYPES = Object.freeze({
    NONE: 'none',
    FILE: 'file',
    TEXT: 'text',
});

export const FORMATIVE_STATUS = Object.freeze({
    DRAFT: 'draft',
    COMPLETE: 'complete',
});

export const ACTIVITY_TYPES = Object.freeze({
    AUTH: 'auth',
    SUBMISSION: 'submission',
});

export const ACTIVITY_ACTIONS = Object.freeze({
    // auth
    LOGIN: 'login',
    LOGOUT: 'logout',
    // submission
    CREATE: 'create',
});

export const RESOURCE_TYPES = Object.freeze({
    FILE: 'file',
    LINK: 'link',
});

export const RUBRIC_OPTION_DESCRIPTION_WORD_COUNT_LIMIT = 600;

export const CUSTOM_CONTENT_WORD_COUNT_LIMIT = 1000;

export const CUSTOM_INSTRUCTIONS_WORD_COUNT_LIMIT = 4000;

export const BASELINE_WORD_COUNT_LIMIT = 7500;

export const PREVIEW_WORD_COUNT_LIMIT = 7500;

export const DESCRIPTION_WORD_COUNT_LIMIT = 7000;

export const FEEDBACK_WORD_COUNT_LIMIT = 7500;

export const FEEDBACK_LIMIT = 3;

export const AI_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://cjfseerku2kn2fr5f7fx47xoqu0tbkbk.lambda-url.us-east-1.on.aws/'
        : 'https://4rf3o4dfbra4o24c2r3ieozhi40dnkmr.lambda-url.us-east-1.on.aws/';

export const AI_REGENERATE_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://2zoe4h3rtx3p2h4u6kzkqeboqq0hehkj.lambda-url.us-east-1.on.aws/'
        : 'https://2zoe4h3rtx3p2h4u6kzkqeboqq0hehkj.lambda-url.us-east-1.on.aws/';

export const AI_FEEDBACKS_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://cjfseerku2kn2fr5f7fx47xoqu0tbkbk.lambda-url.us-east-1.on.aws/'
        : 'https://mdpewo3pcwghxmleg3rmxssrpm0achbk.lambda-url.us-east-1.on.aws/';

export const AI_GRADE_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://ra5p7bk6rig4ccnksdnwa2ztpm0oruxe.lambda-url.us-east-1.on.aws/'
        : 'https://z33horgw3yx2dhev6nljia4p7q0ejveo.lambda-url.us-east-1.on.aws/';

export const AI_RUBRICS_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://oihpcwgcxs4e7slcabvfa3m7mi0rblpm.lambda-url.us-east-1.on.aws/'
        : 'https://5vtpzaspykcf5x3zmpjxds4pii0gkrms.lambda-url.us-east-1.on.aws/';

export const AI_STUDENT_FEEDBACK_URL =
    process.env.REACT_APP_PLATFORM === 'production'
        ? 'https://fwioa36lbfxzrdjzjwuh7varxi0ibrbi.lambda-url.us-east-1.on.aws/'
        : 'https://plgluecbzfwp5626jmen7uvh5y0ggnoe.lambda-url.us-east-1.on.aws/';

export const DEFAULT_FEEDBACK_STRUCTURE = 'rubric';

export const DEFAULT_FEEDBACK_NUM_SUGGESTIONS = '3';

export const DEFAULT_FEEDBACK_SUGGESTION_LENGTH = '<50';

export const DEFAULT_FEEDBACK_LANGUAGE_LEVEL = 'undergraduate';

export const DEFAULT_FEEDBACK_TONE = 'balanced';

export const EXAMPLE_ASSIGNMENT_ID = 'example_assignment_id';

export const EXAMPLE_SUBMISSION_ID = 'example_submission_id';

export const CONTENT_BANK_RESOURCES_MB_LIMIT = 200;
